<template>
  <div>
    <v-container grid-list-md class="pa-0" fluid>
      <v-layout row wrap>
        <v-flex md3 xs12>
          <v-select
            v-if="!loading && companies.length > 1"
            :items="filteredCompanies"
            :item-color="companyPrimaryColor"
            :background-color="$vuetify.theme.themes[theme].menu"
            item-text="name"
            item-value="id"
            hide-details
            v-on:input="loadActiveCompData()"
            v-model="activeComp"
            no-data-text="Geen bedrijven gevonden."
            label="Selecteer bedrijf"
            outlined
            dense
            >
            <template v-slot:prepend-item>
              <v-list-item>
                <v-list-item-content  class="pt-0" >
                  <v-text-field
                    :color="companyPrimaryColor"
                    placeholder="Zoeken"
                    append-icon="search"
                    v-model="searchCompanies"
                    hide-details
                    dense
                  ></v-text-field>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <div v-if="searchCompanies && searchCompanies.length > 0" style="padding: 4px 17px 3px 17px; background-color:rgba(0,0,0, 0.02); color: rgba(0, 0, 0, 0.6); text-align: center; font-size: 12px">{{ filteredCompanies.length }} van {{ companies.length }} bedrijven</div>
              <v-divider v-if="searchCompanies && searchCompanies.length > 0"></v-divider>
            </template>
          </v-select>
        </v-flex>
      </v-layout>
    </v-container>

    <div v-if="loading" class="blackbox-loader"></div>

    <div v-if="loading == false" class="mt-4 special-content-box">
      <v-tabs
          :color="companyPrimaryColor"
          background-color="background"
          show-arrows
          :options="tableOptions"
          >
          <v-tab @click="tab='1'" >Gesprekken</v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <v-tab-item value="1" :transition="tabTransition" :reverse-transition="tabTransition">
            <div class="pa-4">
              <v-container grid-list-md class="pa-0" fluid>
                <v-layout row wrap>
                  <v-flex md8 xs12>
                    <h1 class="tab-title">Gesprekken</h1>
                  </v-flex>
                  <v-flex md4 xs12>
                    <v-row v-if="employeesLoaded && employees.length > 0">
                      <v-text-field
                        class="px-2"
                        v-model="searchConversationRecords"
                        :color="companyPrimaryColor"
                        name="searchfield"
                        placeholder="Zoeken"
                        outlined
                        hide-details                                                     
                        prepend-inner-icon="search"
                        autocomplete="disabled"
                        backgroundColor="background"
                        clearable
                        single-line>
                      </v-text-field>
                      <v-btn class="px-2" fab dark :color="companyPrimaryColor" @click="addDossier()">
                        <v-icon darken>add</v-icon>
                      </v-btn>
                    </v-row>
                  </v-flex>
                </v-layout>
              </v-container>
            </div>

            <div v-if="conversationRecordsLoaded && conversationRecords.length > 0">
              <div v-if="conversationRecords.length > 0">
                <v-data-table
                  :search="searchConversationRecords"
                  :headers="headersConversationRecords"
                  :items="conversationRecords"
                  hide-default-footer
                  single-expand
                  :itemsPerPage.sync="employeesPages"
                  >
                  <template v-slot:item="{item}">
                    <tr>
                      <td>{{ item.created.seconds | moment(" D MMMM YYYY - H:mm") }}u</td>
                      <td>{{ getEmployeeName(item.employee.id) }}</td>
                      <td>{{ item.title }}</td>
                      <td>
                        <v-btn style="float: right;" icon class="mx-0" @click="editDossier(item)">
                          <v-icon small :color="$vuetify.theme.themes[theme].text">edit</v-icon>
                        </v-btn>
                      </td>
                      <td>
                        <v-btn style="float: right;" icon class="mx-0" @click="removeItemDialog(item, 'dossier')">
                          <v-icon small :color="$vuetify.theme.themes[theme].text">delete</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </div>
              <div v-else class="not-found" >
                <div class="hipster-image" :class="randomHipster"></div>
                <p>Geen gesprekken met de naam <strong>{{ searchEmployees }}</strong> gevonden.</p>
              </div>
            </div>

            <div v-if="!conversationRecordsLoaded" class="loading-dots mb-5">
              <div class="loading-dots-loader"></div>
              <p class="loading-dots-text"></p>
            </div>

            <div class="no-competention-data text-center" v-if="conversationRecordsLoaded && conversationRecords.length == 0">
              <p>Nog geen gesprekken toegevoegd</p>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">    
                    <v-btn fab darken color="primary" style="display: block; margin: 15px auto;" @click="addDossier()">
                      <v-icon v-on="on" darken>add</v-icon>
                    </v-btn>
                  </template>
                  <span class="white--text">Voeg een nieuw gesprek toe.</span>
                </v-tooltip>
            </div>
          </v-tab-item>

        </v-tabs-items>
    </div>

        
    <!-- / New Dossier Dialog \-->
    <add-dossier-form :activeCompData="activeCompData" :employees="employees" :positions="positions" :resultAreas="resultAreas" :resultActivities="resultActivities" @updateData="loadConversationRecords()"></add-dossier-form>
    <!-- \ New Dossier Dialog / -->

     <!-- / Edit Dossier Dialog \-->
    <edit-dossier-form :activeCompData="activeCompData" :selectedDossierItem="selectedDossierItem" :selectedDossierItemOriginal="selectedDossierItemOriginal" :employees="employees" :positions="positions" :resultAreas="resultAreas" :resultActivities="resultActivities" @updateData="loadConversationRecords()"></edit-dossier-form>
    <!-- \ Edit Dossier Dialog / -->


    <!-- / Delete Dialog \-->
    <v-dialog v-model="removeItemData.dialog" max-width="450">
      <v-card>
        <v-card-title class="pr-2" :style=" { backgroundColor: companyPrimaryColor }">
          <h2 class="white--text"><span class="white--text" style="text-transform: capitalize;">{{ removeItemData.type }}</span> verwijderen</h2>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="removeItemData.dialog = false">
            <v-icon dark color="white">close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <div class="pt-4"><span style="text-transform: capitalize;">{{ removeItemData.type }}</span> definitief verwijderen?</div>
        </v-card-text>
        
        <v-divider></v-divider>

        <v-card-actions>
          <v-container grid-list-md fluid class="ma-0 pa-0">
            <v-layout row wrap class="ma-0 pa-0">
              <v-flex xs12 md6 class="text-left" v-if="$vuetify.breakpoint.name != 'sm' && $vuetify.breakpoint.name != 'xs'">
                <v-btn
                  outlined
                  depressed
                  color="#8B93A6"
                  @click="removeItemData.dialog = false"
                  >
                  Annuleren
                </v-btn>
              </v-flex>
              <v-flex xs12 md6 class="text-right">
                <v-btn
                  dark
                  rounded
                  :block="$vuetify.breakpoint.name == 'sm' || $vuetify.breakpoint.name == 'xs'"
                  :color="companySecondaryColor"
                  @click="removeItem()"
                  >
                  Verwijderen
                  <v-icon right dark>chevron_right</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-actions>

      </v-card>
    </v-dialog>
    <!-- \ Delete Dialog / -->

  </div>
</template>


<script>
import Vue from "vue";
import { bus } from "../main";
import db from "../firebase/init";
import platform from 'platform'; 
import moment from "moment";

import AddDossierForm from "../components/modals/AddDossierForm.vue";
import EditDossierForm from "../components/modals/EditDossierForm.vue";


export default {
  name: "CompetenieDossiers",
  components: {
    "add-dossier-form": AddDossierForm,
    "edit-dossier-form": EditDossierForm,
  },

  data: () => ({

    conversationRecordsLoaded: false,
    conversationRecords: [],
    searchConversationRecords: "",

    selectedDossierItem: {},
    selectedDossierItemOriginal: {},

    tableOptions: {
      sortBy: 'created.seconds',
      sortDesc: true
    },

    removeDialog: false,
    selectedEmployeeIndex: null,
    employeeBranchScheduleLoading: true,
    employeeBranchScheduleEvents: [],
    employeeBranchScheduleEventsOriginal: [],
    scheduleStartDateRaw: null,
    scheduleStartDateDialog: false,
    scheduleEndDateRaw: null,
    scheduleEndDateDialog: false,

    loading: true,
    feedback: null,
    activeComp: "",
    activeCompData: {},
    activeCompDataOriginal: {},
    positions: [],
    employees: [],
    employeesOriginal: [],
    resultAreas: [],
    resultActivities: [],
    searchCompanies: "",
    employeesPages: -1,
    resultaAreasPages: -1,
    resultActivitiesPages: -1,
    positionPages: -1,
    tabTransition: false,
    tab: "1",
  
    positionsLoaded: false,
    employeesLoaded: false,
    resultActivitiesLoaded: false,
    resultAreasLoaded: false,

    selectedEvent: null,

    removeItemData: {
      dialog: false,
      type: null,
      data: {}
    },

    branches:[],

    pagination: {
      rowsPerPage: -1,
      sortBy: "name",
      descending: true
    },

    headersConversationRecords: [
      {
        text: "Datum",
        align: "left",
        value: "created",
        width: "200px"
      },
      {
        text: "Medewerker",
        align: "left",
        value: "employee",
        width: "200px"
      },
      {
        text: "Naam",
        align: "left",
        value: "name"
      },
      {
        text: "",
        sortable: false,
        align: "right",
        value: "",
        width: "50px"
      },
      {
        text: "",
        sortable: false,
        align: "right",
        value: "",
        width: "50px"
      }
    ],

  }),

  created() {
    this.loadUserComp();
  },

  methods: {

    addDossier(){
      bus.$emit("openAddDossierModal");
    },

    getEmployeeName(id){
      let employeeData = _.find(this.employees, {"id" : id})
      if(employeeData){
        let name = employeeData.firstName + ' ' + employeeData.lastName;
        return name;
      }
      else{
        return null;
      }
    },

    loadBranches(){
      db.collection("branches")
        .where('compId',"==", this.activeCompData.id)
        .get()
        .then(snap => {
          this.branches = [];
          snap.forEach(doc => {
            let branch = doc.data();
            branch.id = doc.id;
            this.branches.push(branch);
          });
        })
        .catch(error =>{
          console.error("Error loading branches: ", error)
        })
    },

    loadPositions(){
      db.collection("positions")
        .where('compId',"==", this.activeCompData.id)
        .where('deleted.deleted',"==", false)
        .get()
        .then(snap => {
          this.positions = [];
          snap.forEach(doc => {
            let position = doc.data();
            position.id = doc.id;
            this.positions.push(position);
          });
        })
        .then(()=>{
          this.positionsLoaded = true
        })
    },

    loadEmployees(){
      db.collection("employees")
        .where('companyId',"==", this.activeCompData.id)
        .where('deleted.deleted',"==", false)
        .get()
        .then(snap => {
          this.employees = [];
          snap.forEach(doc => {
            let employee = doc.data();
            employee.id = doc.id;
            employee.selectedBranch = null;
            if(employee.branches && employee.branches.length > 0){
              employee.selectedBranch = employee.branches[0]
            }
            if(employee.birthdayDate != null){
              let today = moment()
              let birthday = moment.unix(employee.birthdayDate.seconds)
              employee.age = moment.duration(today.diff(birthday)).years();
            } else{
              employee.age = '-'
            }
            this.employees.push(employee);
          });
        })
        .then(()=>{
          this.employeesOriginal = _.cloneDeep(this.employees);
          this.employeesLoaded = true;
        })
    },

    loadResultAreas(){
      db.collection("resultAreas")
        .where('compId',"==", this.activeCompData.id)
        .where('deleted.deleted',"==", false)
        .get()
        .then(snap => {
          this.resultAreas = [];
          snap.forEach(doc => {
            let resultArea = doc.data();
            resultArea.id = doc.id;
            this.resultAreas.push(resultArea);
          });
        })
        .then(()=>{
          this.resultAreasLoaded = true
        })
    },

    loadResultActivities(){
      db.collection("resultActivities")
        .where('compId',"==", this.activeCompData.id)
        .where('deleted.deleted',"==", false)
        .orderBy("order")
        .get()
        .then(snap => {
          this.resultActivities = [];
          snap.forEach(doc => {
            let resultActivity = doc.data();
            resultActivity.id = doc.id;
            this.resultActivities.push(resultActivity);
          });
        })
        .then(()=>{
          this.resultActivitiesLoaded = true
        })
    },

    loadConversationRecords(){
      this.conversationRecordsLoaded = false;
      db.collection("conversationRecords")
        .where('compId',"==", this.activeCompData.id)
        .where('deleted.deleted',"==", false)
        .orderBy("created", "desc")
        .get()
        .then(snap => {
          this.conversationRecords = [];
          snap.forEach(doc => {
            let conversationRecord = doc.data();
            conversationRecord.id = doc.id;
            this.conversationRecords.push(conversationRecord);
          });
        })
        .then(()=>{
          this.conversationRecordsLoaded = true;
        })
    },

    editDossier(item){
      console.log("item: ", item)
      this.selectedDossierItem = _.cloneDeep(item);
      this.selectedDossierItemOriginal = _.cloneDeep(item);
       bus.$emit("openEditDossierModal", this.activeCompData.id, this.selectedDossierItem.employee.id, this.selectedDossierItem.created);
    },

    removeItemDialog(item, type){
      this.removeItemData.type = type
      this.removeItemData.data = item
      this.removeItemData.dialog = true
    },

    removeItem(){
      let collection = null

      if(this.removeItemData.type == 'dossier'){
        collection = 'conversationRecords'
      }

      db.collection(collection)
        .doc(this.removeItemData.data.id)
        .set({
          deleted: {
            deleted: true,
            timestamp: new Date(),
            deletedBy: this.userFirstName + " " + this.userLastName
          }
        }, { merge: true })
        .then(() => {
          if(collection = 'conversationRecords'){
            this.loadConversationRecords();
          }
        })
        .then(()=>{
          this.removeItemData.dialog = false
          this.removeItemData.type = null
          this.removeItemData.data = null
        })
        .catch(error => {
          this.removeItemData.dialog = false
          this.removeItemData.type = null
          this.removeItemData.data = null
          console.error("Error updating ", collection, ": ", error);
        });
    },

    loadUserComp() {
      this.loaded = false;
      let userCompanies = this.userCompanies;
      this.companies = [];
      let counter = 0

      new Promise((resolve, reject)=>{
        this.userCompanies.forEach(company=>{
          db.collection("companies").doc(company).get()
            .then(doc => {
              let company = {};
              company.name = doc.data().name;
              company.id = doc.id;
              this.companies.push(company);
              counter++
              if(counter == this.userCompanies.length){
                resolve()
              }
            })
        })
      })
      .then(()=>{
        // REMEMBER SELECTED COMPANY FROM LOCAL STORAGE
        if(this.userRole == 'superadmin'){
          // Super Admins have access to multiple companies 
          let selectedCompany = window.localStorage.getItem('selectedCompany')

          // Check if a selected company is set in the Local Storage
          if(selectedCompany){
            
            // Check if the selected company is an option
            let selectedCompanyIndex = _.findIndex(this.companies, { 'id': selectedCompany })

            // Selected company is an option, set activeComp
            if(selectedCompanyIndex >= 0){
              this.activeComp = this.companies[selectedCompanyIndex].id;
              this.loadActiveCompData();
            } 
            // Selected company is no option, set first company as activeComp 
            else{
              this.activeComp = this.companies[0].id;
              window.localStorage.setItem('selectedCompany', this.companies[0].id)
              this.loadActiveCompData();
            }
          }
          // No selected company is set 
          else {
            this.activeComp = this.companies[0].id;
            window.localStorage.setItem('selectedCompany', this.companies[0].id)
            this.loadActiveCompData();
          }
        }

        // Regular users have 1 company, just get the first
        else {
          this.activeComp = this.companies[0].id;
          this.loadActiveCompData();
          
        }
      })
    },

    loadActiveCompData() {
      this.loading = true;
      // Set Active Company as Selected Company in Local Storage
      window.localStorage.setItem('selectedCompany', this.activeComp)
      db.collection("companies")
        .doc(this.activeComp)
        .get()
        .then(doc => {
          if (doc.exists) {
            this.activeCompData = doc.data();
            this.activeCompData.id = doc.id;
          } else {
            console.log("No such document!");
          }
        })
        .then(() => {
          this.activeCompDataOriginal = _.cloneDeep(this.activeCompData);

          this.loadConversationRecords();
          this.loadPositions();
          this.loadEmployees();
          this.loadResultAreas();
          this.loadResultActivities();

        })
        .then(() => {
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          console.error("Error getting document:", error);
        });
    },

  },

  computed: {
    resultActivitiesPosition(){
      return id => _.filter(this.resultActivities, ['position', id]);
    },

    randomHipster(){
      let randomNumber = Math.floor(Math.random() * 12) + 1;
      let hipsterClass = "hipster-" + randomNumber
      return hipsterClass    
    },

    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },

    theme(){
      return (this.$vuetify.theme.dark) ? 'dark' : 'light'
    },

    filteredCompanies(){
      if(this.searchCompanies && this.searchCompanies.length > 0){
        return this.companies.filter(company => {
          return company.name.toLowerCase().includes(this.searchCompanies.toLowerCase());
        });
      } else {
        return this.companies
      }
    },

    changed() {
      if(this.activeCompData.conversion.start && this.activeCompData.conversion.start.seconds){
        if (moment.unix(this.activeCompData.conversion.start.seconds).format("D MMMM YYYY") != this.conversionStartDate) {
          return true;
        } else {
          return false;
        }
      } else{
        if (this.conversionStartDate) {
          return true;
        } else {
          return false;
        }
      }
    }

  }
};
</script>

<style scoped>
  .no-competention-data{
    width: 350px;
    margin: 0 auto;
    padding: 250px 0;
  }

  .conversion-source-tags{
    margin: 15px 0;
    padding: 10px 5px;
    background-color: #f9f9f9;
  }
  .conversion-source-tags:after{
    clear: both;
    display: block;
    content: "";
  }
</style>
